import type { AllRouteEndpoints } from "../routeTypes";

export const campaignQaRun = "/:app_group_id/campaign_qa_runs/:campaign_id";

export const campaignQaRunCacheKeys: AllRouteEndpoints[] = ["/:app_group_id/campaign_qa_runs/:campaign_id"];
